module.exports = __webpack_public_path__ + "media/assets/images/logos/logo_votorantim-db836e4cfcc1a8149b93840a62ced33f.png";